module.exports = __webpack_public_path__ + "img/checkout.9e18aa3c.png";